import { FEATURES_TOP_ROW } from '../data'
import FeaturesOutput from '../components/FeaturesOutput'

export const Features = () => {
  return (
  <>
    <div className="mb-8">
      <FeaturesOutput DATA={FEATURES_TOP_ROW} />
    </div>
  </>
  )
}